import { useState, useEffect } from 'react';
// import { getStudiesStats } from '../utils/api';
import { getStudiesStats, getRecentSubmissions } from '../../../Config/api';

export const useDashboard = () => {
    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState([]);
    const [submissionData, setSubmissionData] = useState({
        dates: [],
        submitted: [],
        drafts: []
    });
    const [recentSubmissions, setRecentSubmissions] = useState([]);
    const [confirmModal, setConfirmModal] = useState({
        show: false,
        title: '',
        message: '',
        type: '',
        onConfirm: () => { }
    });

    const fetchDashboardData = async () => {
        try {
            setLoading(true);
            const data = await getStudiesStats();

            if (data.success) {
                if (data.data.stats) {
                    const statsData = data.data.stats;
                    setStats([
                        {
                            title: 'Total Sites',
                            value: statsData.totalSites?.toString() || '0',
                            change: '',
                            color: '#f59e0b'
                        },
                        {
                            title: 'Total Submissions',
                            value: statsData.totalSubmissions?.toString() || '0',
                            change: '',
                            color: '#10b981'
                        },
                        {
                            title: 'Completed',
                            value: statsData.totalCompleted?.toString() || '0',
                            change: '',
                            color: '#3b82f6'
                        },
                        {
                            title: 'Drafts',
                            value: statsData.totalDrafts?.toString() || '0',
                            change: '',
                            color: '#8b5cf6'
                        }
                    ]);
                }

                if (data.data.graphData && data.data.graphData.length > 0) {
                    const dates = data.data.graphData.map(item => item.date);
                    const submitted = data.data.graphData.map(item => item.submitted || 0);
                    const drafts = data.data.graphData.map(item => item.drafts || 0);

                    setSubmissionData({
                        dates: dates,
                        submitted: submitted,
                        drafts: drafts
                    });
                }
            } else {
                setConfirmModal({
                    show: true,
                    title: 'Error',
                    message: data.message || 'Failed to fetch dashboard data',
                    type: 'error',
                    onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
                });
            }
        } catch (error) {
            setConfirmModal({
                show: true,
                title: 'Error',
                message: 'Failed to fetch dashboard data',
                type: 'error',
                onConfirm: () => setConfirmModal({ ...confirmModal, show: false })
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchRecentSubmissions = async () => {
        try {
            const data = await getRecentSubmissions();

            if (data.success) {
                setRecentSubmissions(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching recent submissions:', error);
        }
    };

    useEffect(() => {
        fetchDashboardData();
        fetchRecentSubmissions();
    }, []);

    return {
        loading,
        stats,
        submissionData,
        recentSubmissions,
        confirmModal,
        setConfirmModal
    };
};